@use "variables" as *;

.container {
  display: flex !important;
  align-items: center;
  justify-content: center;
  position: relative;
  aspect-ratio: 1;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 100%;
}

.spineImage {
  display: block;
  width: auto;
  height: 100%;
  max-width: 100%;
}

.blurDiv {
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}
